import { NgModule } from '@angular/core';
import { LordIconCleanupDirective } from '../sharedUI/lord-icon-cleanup.directive';

@NgModule({
  imports: [  ],
  declarations: [
    LordIconCleanupDirective,
  ],
  exports: [
    LordIconCleanupDirective,
     // optionally export CommonModule so consumers don't repeat it
  ]
})
export class UiSharedModule {}
